import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import QuotationResponseModal from "./QuotationResponseModal";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


const QuotationResponsePage = () => {
  const { quotationId } = useParams();
  const [searchParams] = useSearchParams();
  const [showModal, setShowModal] = useState(false);
    const [closed, setClosed] = useState(false); // tracks user cancellation

  const navigate = useNavigate();

  const action = searchParams.get("action");
  const validActions = ["accept", "reject", "counter"];

  useEffect(() => {
    if (quotationId && validActions.includes(action)) {
      setShowModal(true);
    }
  }, [quotationId, action]);

  if (!quotationId || !validActions.includes(action)) {
    return (
      <div style={{ padding: "30px", textAlign: "center", color: "#c00" }}>
        Invalid or missing quotation response link.
      </div>
    );
  }
    if (closed) return null; // Hide everything if user cancelled



  if (!showModal) {
    return (
      <div style={{ padding: "30px", textAlign: "center" }}>
        Loading response form...
      </div>
    );
  }

  return (
            <>
      {showModal && (
        <QuotationResponseModal
          quotationId={quotationId}
          action={action}
         onClose={(reason) => {
  setShowModal(false);
  if (reason === "submitted") {
    toast.success("Thank you for your response!");
  } else {
    setClosed(true);
  }
}}

        />
      )}

          <ToastContainer position="top-center" autoClose={3000} />

    </>
    

  );
};

export default QuotationResponsePage;
